import React from "react";
import "./style/about.css";

const About = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-content">
          <h1>About Our Company</h1>
          <p>
            Welcome to M/s. TECHSOLN ENTERPRISE, where expertise in water and
            wastewater treatment meets a commitment to excellence. We are a
            dedicated team of professionals with a passion for creating
            sustainable solutions to the complex challenges facing water
            management today.
          </p>
          <p>
            M/s. TECHSOLN ENTERPRISE is a leading consulting firm specializing
            in water and wastewater treatment. We embrace new technologies and
            methodologies to provide forward-thinking solutions.
          </p>
          <p>
            Our team consists of extensive knowledge and experienced engineers
            who bring a wealth of knowledge and hands-on experience to water
            and wastewater treatments (operations, maintenance, and projects).
          </p>
          <p>
            We prioritize your needs and work diligently to deliver results that
            meet your objectives and exceed your expectations. We are dedicated
            to developing solutions that not only solve immediate challenges but
            also contribute to long-term environmental stewardship.
          </p>
          <h2>We Offer the Following Products & Services:</h2>

          <h4>◾ Wastewater Treatment Plants</h4>
          <ul>
            <li>Effluent Treatment Plant (ETP)</li>
            <li>Industrial RO plant (RO)</li>
            <li>Pharmaceutical loop system with EDI UNITS</li>
            <li>Treated Effluent recycling RO plants (Membrane systems)</li>
            <li>Ultrafiltration plants after STP Plant and before RO plants</li>
            <li>Nano filtration System before RO</li>
            <li>
              Compact sewage Treatment Plants (MBBR, Electrolysis, MBR, and SBR
              Technology)
            </li>
          </ul>

          <h4>◾ Water Treatment Plants</h4>
          <ul>
            <li>
              Industrial RO Plants for (Pharmaceutical industries and other
              sectors)
            </li>
            <li>DM Plant with policing unit Mixed plant</li>
            <li>
              Water softener - domestic / industrial – automatic / manual
            </li>
            <li>Pressure sand filter (PSF)</li>
            <li>Activated carbon filter (ACF) and Dual Media filter (DMF)</li>
            <li>UV System</li>
            <li>Nano filtration and Ultrafiltration</li>
          </ul>

          <h4>◾ Chemicals & Spares</h4>
          <ul>
            <li>
              Chemical & Spares for all types of water and wastewater treatment
              plants (Resin, membrane, pumps, etc…)
            </li>
            <li>
              Consulting for any type of operation and maintenance
              troubleshooting in pre-treatment system, RO, ETP & STP
            </li>
            <li>AMC contract of RO, ETP & STP</li>
          </ul>
        </div>
        {/* <div className="about-image">
          <img
            src="https://via.placeholder.com/400x300"
            alt="Water Filter Company"
          />
        </div> */}
      </div>
    </div>
  );
};

export default About;
